<template>
  <div class="animated fadeIn">
    <b-form @submit="exportJson">
      <b-form-group
              label="From Date:"
              description="This field is required"
      >
        <b-form-input
                v-model="form.date_from"
                type="date"
                required
        ></b-form-input>
      </b-form-group>
      <b-form-group
              label="To Date:"
              description="This field is required"
      >
        <b-form-input
                v-model="form.date_to"
                type="date"
                required
        ></b-form-input>
      </b-form-group>

      <div class="text-right">
        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Process and Download File</b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import { server_details } from "@/config";
    export default {
      mixins:[SwalMixin],
      data: () => {
          return {
            form:{
              date_from:'',
              date_to:''
            },
            projects:[]
          }
      },
      created(){
      },
      methods: {
        exportJson(){
          event.preventDefault()
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_saving=true;
              this.axios.post('export/logs',this.form).then(response => {
                this.swalTransactionCompleted();
                window.location.href = server_details.BASE_SERVER_URL+"/export-logs/"+response.data;
              }).catch(error => {
                console.log(error)
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
              });
            }
          });
        },
      }
    }
</script>
